export default "__VITE_ASSET__DMuDfbrI__"